import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone'
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import AppConfig from '../../utils/appConfig.js';

export const BYTES_PER_KB = AppConfig.UploadConfig.bytesPerKB;

const log = new Logger('UPLOAD_PANEL', LOG_LEVELS.DEBUG);

// TODO: Change to use a redux mechanism. Or the forms stuff.
export class UploadPanel extends Component {
  constructor(props) {
    super(props);
    if (this.props.loadExistingFile.length > 0)
    {
      this.state = { filesToBeSent:this.props.loadExistingFile};
    }else{
      this.state = { filesToBeSent:[]}
    }
  }
  render() {
    log.debug('render: ', this.props);

    const filesLeftToAdd = this.props.uploadLimit - this.state.filesToBeSent.length;
    let maxSizeInBytes = null;
    if(this.props.maxSizeInKB && !Number.isNaN(this.props.maxSizeInKB)) {
      maxSizeInBytes = this.props.maxSizeInKB * BYTES_PER_KB;
    } else {
      maxSizeInBytes = AppConfig.UploadConfig.maxFileSize * BYTES_PER_KB
    }
    return (
      <div className="App">
        <div>
        </div>
        <center>
          <div className="dropzone">
            <Dropzone className={filesLeftToAdd > 0 ? 'mb5 height100' : 'mb15 file-active height100'}
                      activeClassName="active"
                      accept={this.props.acceptTypes.join(', ')}
                      onDrop={this.onDrop.bind(this)}
                      maxSize={maxSizeInBytes}
                >
              <div className="droparea">
              {
              (filesLeftToAdd > 0) ?
                (
                  <div>
                    <h2 className="mb10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'dragAndDrop')}</h2>
                    <button className="primary" disabled = {this.props.disabled} data-test="button-select-file">{LANGUAGES_CONTROLLER.format(this.props.languages, 'selectFile')}</button>
                  </div>) :
                ('')
              }
              </div>
            </Dropzone>
            {
            (filesLeftToAdd > 0) ?
              ('') :
              (
                <div className="drop-success" data-test="component-drop-success">
                  <h2 className="mb5">{LANGUAGES_CONTROLLER.format(this.props.languages, 'toBeUploaded')}</h2>
                  {
                    this.state.filesToBeSent.map((file, index) => {return (
                      <div key={index}>
                        <div className="mb20 success"> {file.name}</div>
                      </div>

                    )})
                  }
                  <button disabled = {this.props.disabled} className="primary upload mt0 mb0" data-test="button-upload-file" label="Upload Files" onClick={this.onUserUploadRequest.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'upload')}</button>
                  <button className="secondary mt0 mb0" label="Cancel" data-test="button-upload-cancel" onClick={this.onClearFiles.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'cancel')}</button>
                </div>
              )
            }
          </div>

        </center>
      </div>
    );
  }
  onDrop(acceptedFiles, rejectedFiles) {
    log.debug('onDrop: accepted files: ', acceptedFiles);
    log.debug('onDrop: rejected files: ', rejectedFiles);
    log.debug('onDrop: state: ', this.state);

    if (acceptedFiles && acceptedFiles.length > 0)
    {
      let filesToBeSent=this.state.filesToBeSent;
      if (filesToBeSent.length + acceptedFiles.length > this.props.uploadLimit) {
        // TODO: dispatch an error message, rather than alert
        alert("Multiple file uploads at once are not supported");
        return;
      }
      filesToBeSent = filesToBeSent.concat(acceptedFiles);

      this.setState({filesToBeSent});
    }

    if (rejectedFiles && rejectedFiles.length > 0) {
      alert("Your file has been rejected - please check the accepted file formats or file size limits");
    }

  }

  onClearFiles() {
      log.debug('onClearFiles: ');
      this.props.onClearFiles();
      this.setState({filesToBeSent: []});
  }

  onUserUploadRequest(evt) {
    log.debug('onUserUploadRequest: ', evt);
    if(this.state.filesToBeSent.length > 0){
      this.props.onUploadRequest(this.state.filesToBeSent);
      // TODO: Wait for the success / fail of the upload. Use redux for this.
    if(this.props.clearSelection)
       this.setState({filesToBeSent: []});
    }
    else{
      alert("Please upload some files first");
    }
  }

}

// redux mapping of
function mapStateToProps(state) {
  return {
    languages: state.languages,
  };
}


UploadPanel.defaultProps = {
  maxSizeInKB: AppConfig.UploadConfig.maxFileSize,
  clearSelection: true,
  onClearFiles: ()=>{},
  loadExistingFile:[],
  disabled: false
}

export default connect(mapStateToProps)(UploadPanel);